import { makeStyles } from '../../../styles/helpers';
export const useStyles = makeStyles((theme) => ({
    root: {
        '&.Mui-disabled': {
            color: theme.colors.gray[200],
            '&:hover': {
                color: theme.colors.gray[200],
            },
        },
    },
}));
//# sourceMappingURL=Checkbox.styles.js.map